export default __webpack_public_path__ + "static/hashimoto-559c0c6b57da0f096da954e7e79f9263.png";